import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Library, OPTIONS } from '../library';

@Injectable({
  providedIn: 'root'
})
export class ChargeService {

  constructor(private http: HttpClient) { }

  createUpdateCharge(chargeForm: any) {
    return this.http.post<any>(Library.API_ENDPOINT + 'charge/save_update_charge', chargeForm, OPTIONS);
  }

  getCharges() {
    return this.http.get<any>(Library.API_ENDPOINT + 'charge/get_charges', OPTIONS);
  }

  getLoanCharges() {
    return this.http.get<any>(Library.API_ENDPOINT + 'charge/get_loan_charges', OPTIONS);
  }

  deleteCharge(id: number) {
    return this.http.post<any>(Library.API_ENDPOINT + `charge/delete_charge/${id}`, {}, OPTIONS);
  }

  getTaxCategories() {
    return this.http.get<any>(Library.API_ENDPOINT + 'charge/get_tax_categories', OPTIONS);
  }
}
